import { Textarea } from './Input.tsx'

interface CommentComposerProps {
  value: string
  onChange: (v: string) => void
  onSend: () => void
  disabled?: boolean
}

/**
 * Поле комментария. Кнопка «Отправить» — это MainButton экрана (пока поле не пустое),
 * Ctrl/⌘+Enter тоже отправляет.
 */
export function CommentComposer({ value, onChange, onSend, disabled }: CommentComposerProps) {
  return (
    <div className="composer">
      <Textarea
        autoGrow
        rows={1}
        value={value}
        disabled={disabled}
        maxLength={4000}
        placeholder="Написать комментарий…"
        aria-label="Комментарий"
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && value.trim()) {
            e.preventDefault()
            onSend()
          }
        }}
      />
    </div>
  )
}
